import { NavLink, Link } from 'react-router-dom';
import { MaterialIcon } from '@/components/common/MaterialIcon';
import { cn } from '@/lib/cn';

const TABS = [
  { to: '/', label: 'Home', icon: 'home' },
  { to: '/prayer-times', label: 'Prayers', icon: 'schedule' },
  { to: '/events', label: 'Events', icon: 'event' },
  { to: '/profile', label: 'Profile', icon: 'person' },
] as const;

/**
 * Floating mobile bottom navigation with a centered Donate FAB.
 * Ported from home_al_noor_mosque_mobile/code.html (the mobile-only
 * thumb-friendly nav). Hidden on md+ breakpoints.
 */
export function MobileBottomNav() {
  return (
    <nav
      aria-label="Mobile primary"
      className="glass-card fixed bottom-6 left-1/2 z-50 flex w-[90%] -translate-x-1/2 items-center justify-around rounded-2xl border-secondary/20 px-2 py-3 shadow-2xl md:hidden"
    >
      <TabLink {...TABS[0]} />
      <TabLink {...TABS[1]} />

      <div className="relative -top-8">
        <Link
          to="/donate"
          aria-label="Donate"
          className="flex h-14 w-14 items-center justify-center rounded-full border-4 border-surface bg-secondary text-white shadow-xl"
        >
          <MaterialIcon name="volunteer_activism" className="text-3xl" />
        </Link>
      </div>

      <TabLink {...TABS[2]} />
      <TabLink {...TABS[3]} />
    </nav>
  );
}

function TabLink({
  to,
  label,
  icon,
}: {
  to: string;
  label: string;
  icon: string;
}) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) =>
        cn(
          'flex min-h-[44px] min-w-[44px] flex-col items-center justify-center gap-0.5 px-2',
          isActive ? 'text-secondary' : 'text-on-surface-variant',
        )
      }
    >
      {({ isActive }) => (
        <>
          <MaterialIcon name={icon} filled={isActive} />
          <span className="font-label-caps text-[11px] leading-tight">{label}</span>
        </>
      )}
    </NavLink>
  );
}
